import type { EmailToTaskFormApi } from "@/hooks/useEmailToTaskForm";
import { SectionBlock } from "../SectionBlock";
import { Field, TagListInput, ToggleRow } from "./fields";

export function SenderRulesCard({ form, setField, disabled }: EmailToTaskFormApi) {
	return (
		<SectionBlock
			title="Sender rules"
			description="A sender is accepted when it matches any allowed domain or any allowed email. Rejected emails are kept as ignored with the reason."
		>
			<div className="grid gap-4 sm:grid-cols-2">
				<Field label="Allowed sender domains" htmlFor="ett-domains" hint="Press Enter or comma to add.">
					<TagListInput
						id="ett-domains"
						values={form.allowed_sender_domains}
						onChange={(v) => setField("allowed_sender_domains", v)}
						placeholder="uptodatewebdesign.com"
						disabled={disabled}
					/>
				</Field>
				<Field label="Allowed sender emails" htmlFor="ett-emails" hint="Specific addresses, from any domain.">
					<TagListInput
						id="ett-emails"
						values={form.allowed_sender_emails}
						onChange={(v) => setField("allowed_sender_emails", v)}
						placeholder="name@company.com"
						disabled={disabled}
					/>
				</Field>
			</div>
			<div className="mt-3 divide-y divide-border">
				<ToggleRow
					label="Sender must be an active TaskHub user"
					checked={form.require_taskhub_user}
					onChange={(v) => setField("require_taskhub_user", v)}
					disabled={disabled}
				/>
				<ToggleRow
					label="Require DKIM pass"
					description="Rejects emails whose sender domain signature cannot be verified. The From address alone can be forged."
					checked={form.require_dkim_pass}
					onChange={(v) => setField("require_dkim_pass", v)}
					disabled={disabled}
				/>
			</div>
		</SectionBlock>
	);
}
